import React, { useEffect } from 'react';
import DeviceDetection from '../utils/DeviceDetection';
import './MobileIncompatiblePage.css';

/**
 * MobileIncompatiblePage Component
 *
 * Displayed to mobile users to inform them that the web app is not supported
 * on their device and provides links to download the native mobile apps
 */
const MobileIncompatiblePage = () => {
  const deviceType = DeviceDetection.getDeviceType();
  const appUrls = DeviceDetection.getAppStoreUrls();

  const handleAppDownload = platform => {
    if (platform === 'ios') {
      window.location.href = appUrls.ios;
    } else if (platform === 'android') {
      window.location.href = appUrls.android;
    } else {
      window.location.href = appUrls.fallback;
    }
  };

  useEffect(() => {
    document.title = 'BKFC+ | Mobile Web Not Supported';
  }, []);

  return (
    <div className="mobile-incompatible-page">
      <div className="mobile-incompatible-container">
        {/* BKFC+ Logo */}
        <div className="mobile-incompatible-logo">
          <img
            src="/assets/images/BKFC.png"
            alt="BKFC+"
            className="logo-image"
            onError={e => {
              // Fallback to text logo if image fails
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'block';
            }}
          />
          <div className="logo-text" style={{ display: 'none' }}>
            <img
              src="/logo192.png"
              alt="BKFC+"
              className="fallback-logo"
              onError={e => {
                // Final fallback to text
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <h1 className="text-logo" style={{ display: 'none' }}>
              BKFC+
            </h1>
          </div>
        </div>

        {/* Main Message */}
        <div className="mobile-incompatible-content">
          <div className="mobile-icon">BKFC+</div>

          <h2 className="mobile-incompatible-title">Mobile Web Not Supported</h2>

          <p className="mobile-incompatible-description">
            Watch BKFC+ on your phone in our native app. Download from the App Store or Google Play
            to continue.
          </p>

          <div className="device-info">
            <span className="device-detected">Device detected: {deviceType}</span>
          </div>
        </div>

        {/* App Download Buttons */}
        <div className="app-download-section">
          <h3 className="download-title">Get BKFC+</h3>

          <div className="download-buttons">
            {/* iOS App Store Button */}
            <button className="download-button ios-button" onClick={() => handleAppDownload('ios')}>
              <img
                src="/assets/images/App Store.png"
                alt="Download on the App Store"
                className="store-badge"
              />
            </button>

            {/* Android Play Store Button */}
            <button
              className="download-button android-button"
              onClick={() => handleAppDownload('android')}
            >
              <img
                src="/assets/images/Google Play.png"
                alt="Get it on Google Play"
                className="store-badge"
              />
            </button>
          </div>
        </div>

        {/* Footer Information */}
        <div className="mobile-incompatible-footer">
          <div className="footer-links">
            <a
              href="https://www.bkfc.com/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              Privacy Policy
            </a>
            <span className="footer-separator">•</span>
            <a
              href="https://www.bkfc.com/terms-of-use"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              Terms
            </a>
            <span className="footer-separator">•</span>
            <a
              href="https://www.bkfc.com/about"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              About
            </a>
            <span className="footer-separator">•</span>
            <a
              href="https://www.bkfc.com/contact"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              Contact
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileIncompatiblePage;
